import { Skeleton, SkeletonCard } from '../SkeletonComponents';

/**
 * Skeleton for the Activity tab CONTENT ONLY
 * Used within GroupPageLayout - no header or tabs included
 * Matches: ActivityFeedPresentation loading state
 */
export function ActivityContentSkeleton() {
  return (
    <div className="space-y-4" data-testid="activity-feed-loading">
      {/* Header with filter toggle - matches ActivityFeedPresentation */}
      <div className="flex items-center justify-between mb-4">
        {/* Empty div for spacing (title not shown when showTitle=false) */}
        <div />
        {/* Filter toggle buttons */}
        <div className="flex items-center gap-2">
          <Skeleton className="w-12 h-8 rounded-full" />
          <Skeleton className="w-12 h-8 rounded-full" />
        </div>
      </div>

      {/* Activity cards - matches ExpenseCard compact structure */}
      {[1, 2, 3].map(i => (
        <SkeletonCard key={i} className="p-4">
          <div className="animate-pulse">
            {/* Compact two-column layout */}
            <div className="flex gap-3">
              <Skeleton className="w-8 h-8 rounded-lg shrink-0" />
              <div className="flex-1 min-w-0 space-y-1.5">
                <Skeleton className="h-4 w-1/2" />
                <Skeleton className="h-3 w-1/3" />
              </div>
              <div className="text-right shrink-0 space-y-1.5">
                <Skeleton className="h-5 w-16 ml-auto" />
                <Skeleton className="h-3 w-12 ml-auto" />
              </div>
            </div>

            {/* Position indicator skeleton */}
            <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700">
              <Skeleton className="h-4 w-32" />
            </div>

            {/* Interactions skeleton */}
            <div className="mt-3 pt-3 border-t border-gray-100 dark:border-gray-700 flex justify-between">
              <Skeleton className="h-6 w-24" />
              <div className="flex gap-2">
                <Skeleton className="h-4 w-8" />
                <Skeleton className="h-4 w-8" />
              </div>
            </div>
          </div>
        </SkeletonCard>
      ))}
    </div>
  );
}

/**
 * Full page skeleton for Activity page (standalone use)
 * @deprecated Use ActivityContentSkeleton with GroupPageLayout instead
 */
export function ActivityPageSkeleton() {
  return (
    <div className="max-w-2xl mx-auto space-y-8">
      <ActivityContentSkeleton />
    </div>
  );
}
